import React from "react";
import Grid from "@material-ui/core/Grid";
import { Link } from "gatsby";
import { withStyles, Typography, Button } from "@material-ui/core";

const styles = {
  footer: {
    minHeight: 160,
    background: 'linear-gradient(45deg, #ff6600 50%, #ff0084 70%)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    paddingRight: "12%",
    paddingLeft: "12%",
    paddingTop: 24,
    paddingBottom: 24
  }
};

class Footer extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Grid
        container
        className={classes.footer}
        alignContent="center"
        justify="space-around"
      >
        <Grid item md={4}>
          <Typography variant="h5" color="secondary" align="left">
            gym.js
          </Typography>
        </Grid>
        <Grid item md={4} />
        <Grid container item md={4} direction="column">
          <Typography variant="body2" component="div" color="secondary" align="right">
            <Grid item>
              <Link to={`/`} className={classes.menu}>
                <Button color="secondary">Home</Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to={`/env/`} className={classes.menu}>
                <Button color="secondary">Environments</Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to={`/about/`} className={classes.menu}>
                <Button color="secondary">About</Button>
              </Link>
            </Grid>
            <Grid item>
              <a
                href="https://ttumiel.github.io/gym.js/"
                className={classes.menu}
              >
                <Button color="secondary">Docs</Button>
              </a>
            </Grid>
          </Typography>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(Footer);
